const MEETING_STATUSES = [
    { value: "scheduled", label: "Scheduled" },
    { value: "attended", label: "Attended" },
    { value: "no_show", label: "No Show" },
    { value: "cancelled", label: "Cancelled" },
    { value: "rescheduled", label: "Rescheduled" },
];

const MEETING_OUTCOMES = [
    { value: "continue_next_step", label: "Continue / Next Step" },
    { value: "proposal_requested", label: "Proposal Requested" },
    { value: "follow_up_later", label: "Follow Up Later" },
    { value: "not_interested", label: "Not Interested" },
    { value: "not_a_fit", label: "Not a Fit" },
];

function optionLabel(options, value) {
    return options.find((option) => option.value === String(value || "").toLowerCase())?.label || String(value || "").replaceAll("_", " ").replace(/^./, (letter) => letter.toUpperCase());
}

export function getMeetingStatusLabel(value) {
    return optionLabel(MEETING_STATUSES, value);
}

export function getMeetingOutcomeLabel(value) {
    return optionLabel(MEETING_OUTCOMES, value);
}

export { MEETING_STATUSES, MEETING_OUTCOMES };